import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { Button } from "@mui/material";
import i18n from "../../../i18n";

import CreateTicketDialog from "../../dialog/CreateTicketDialog";
import useDialog from "../../../hooks/useDialog";

import { useAsync } from "../../../hooks/useAsync";

import useTicketService from "../../../services/ticketService";
import CreateTicketOfferReservationForm from "../../form/CreateTicketOfferReservationForm";

function AddCleaningSuppliesButton(props) {
  const ticketDialogReadOnlyFields = ["std_ticket", "ticket_category"];

  const [
    openCreateTicketDialog,
    onOpenCreateTicketDialog,
    onCloseCreateTicketDialog,
  ] = useDialog();

  const { getTicketOfferReservationConfig } = useTicketService();
  const ticketConfigData = useAsync(() =>
    getTicketOfferReservationConfig({ std_ticket_key: "cleaning_supplies" })
  );
  const [ticketInitialData, setTicketInitialData] = useState();
  useEffect(() => {
    if (ticketConfigData.loading) return;

    setTicketInitialData({
      std_ticket: ticketConfigData.value.std_ticket_id,
      ticket_name: ticketConfigData.value.std_ticket_name,
      ticket_category: ticketConfigData.value.ticket_category_id,
      extraData: {},
    });
  }, [ticketConfigData.loading]);

  const handleCloseCreateTicketDialog = (existChanges) => {
    onCloseCreateTicketDialog();
    if (existChanges && props.onSubmitCreateTicket) {
      props.onSubmitCreateTicket();
    }
  };

  return (
    <>
      <Button
        fullWidth
        variant="contained"
        size="small"
        onClick={onOpenCreateTicketDialog}
        color={props.color}
      >
        {i18n.t("tabs.warehouse_transaction_tabs.add_cleaning_supplies")}
      </Button>
      {openCreateTicketDialog && ticketInitialData && (
        <CreateTicketDialog
          open={openCreateTicketDialog}
          onClose={handleCloseCreateTicketDialog}
          returnTrueIfTicketCanceled={false}
          initialData={ticketInitialData}
          readOnlyFields={ticketDialogReadOnlyFields}
          allowOnlySingleLocation={true}
          extraForm={<CreateTicketOfferReservationForm />}
          extraRequiredFields={["owner", "warehouse"]}
          allwaysGetDefaultLocationFromUser
          allwaysGetDefaultLocationFromOm
        />
      )}
    </>
  );
}

AddCleaningSuppliesButton.propTypes = {
  color: PropTypes.string,
  selectedEquipmentIds: PropTypes.array,
  onSubmitCreateTicket: PropTypes.func,
};

AddCleaningSuppliesButton.defaultProps = {
  color: "primary",
};

export default AddCleaningSuppliesButton;
